import moment from "moment";
import * as React from "react";

export class PrettyDate extends React.Component<any, any> {
  static defaultProps = {
    color: "grey",
    lightSwatch: 500,
    fontSize: "0.8rem",
    fontWeight: "400"
  };

  timeDiff() {
    return moment(this.props.children || this.props.text).fromNow();
  }

  render() {
    return (
      <span className={""} style={{}}>
        {this.timeDiff()}
      </span>
    );
  }
}
